<div class="flex gap-2 items-center">
  <p-input-mask
    mask="999999-9999"
    [(ngModel)]="searchCpr"
    (keyup.enter)="findKunde($event)" />
  <p-button
    label="Vælg kunde"
    outlined
    size="small"
    (click)="findKunde($event)"></p-button>
</div>

<p-popover #pop>
  <div class="flex flex-col gap-4">
    <div>
      @if (result().length > 0) {
        <span class="font-medium block mb-2">Vælg kunde</span>
        <ul class="list-none p-0 m-0 flex flex-col">
          @for (k of result(); track k.id) {
            <li
              class="flex items-center gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border"
              (click)="selectKunde(k)">
              <div>
                <span class="font-medium">{{ k.navn }}</span>
                <div class="text-sm text-surface-500 dark:text-surface-400">
                  {{ k.pengeinstitut?.navn }}
                </div>
              </div>
            </li>
          }
        </ul>
      } @else {
        <div>Ingen kunder fundet med dette CPR nummer</div>
      }
    </div>
  </div>
</p-popover>
